<div class="fullcontainer" >
  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header' style='color:#006598;'>All Products</h2>
    <div>
      <button class='btn btn-secondary' routerLink='/quoting/products/new'><i class="fas fa-plus"></i> New</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/quoting'><i class="fas fa-arrow-left"></i> Back</button>&nbsp;
    </div>
  </div>
  <br />
  <br />
  <app-grid
entity='product'
[filters]='this.filters'
[columns]='this.columns'
[buttons]='this.buttons'
[searchFilters]='this.searchFilters'
[searchFields]='this.searchFields'
></app-grid>
